module.exports = __webpack_public_path__ + "img/wind-decoration-with-plants.c5533d31.webp";